import { createContext } from "react";

const DF_LO0023Context = createContext();

export { DF_LO0023Context };